import Vue from 'vue'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import TileTakeoff from '@/components/DynamicComponents/Projects/NewConstruction/TileTakeoff'
import Takeoff from '@/components/DynamicComponents/Projects/NewConstruction/Takeoff'
import AddTile from '@/components/DynamicComponents/Projects/NewConstruction/AddTile'
import TakeoffRelation from '@/components/DynamicComponents/Projects/NewConstruction/TakeoffRelation'
import exportTemplates from '@/components/DynamicComponents/Projects/Export'
import importTemplates from '@/components/DynamicComponents/Projects/Import'
import MoveTile from '@/components/DynamicComponents/Projects/NewConstruction/MoveTiles'
import { formatCurrency } from '@/services/convert'
import { showNotification, calculateHeight } from '@/services/calculate'
import { checkFiles } from '@/services/config'

export default {
  components: {
    'actual-cost-takeoff': Takeoff,
    'tile-takeoff': TileTakeoff,
    'add-tile': AddTile,
    'export-level': exportTemplates,
    'import-level': importTemplates,
    'takeoff-relation': TakeoffRelation,
    'move-tile': MoveTile,
  },
  props: [
    'item',
    'assetId',
    'dropdownData',
    'screenIndentifier',
    'costBasis',
    'projectData',
  ],
  data() {
    return {
      columnDefs: [],
      loader: false,
      create: new Vue(),
      width: '100%',
      height: '30rem',
      list: [],
      formatCurrency: formatCurrency,
      visible: false,
      visibleTile: false,
      visibleMoveTile: false,
      loading: false,
      levelIndex: 0,
      editLevel: false,
      loaderText: false,
      editTile: false,
      loaderTileText: false,
      visibleTakeoff: false,
      costDetails: null,
      type: undefined,
      takeoffs: [],
      sequence: undefined,
      parentLevelTotal: 0,
      form: {
        id: undefined,
        name: undefined,
        sequence: undefined,
        levelId: undefined,
        type: undefined,
      },
      rules: {
        levelId: [
          {
            required: true,
            message: `Please select level`,
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: `Please enter level`,
            trigger: 'blur',
          },
        ],
      },
      levels: [],
      levelDetails: null,
      cardHeight: '32rem',
      tileCardHeight: '23rem',
      isAdjustmentTile: false,
      isAddTile: false,
      tiles: [],
      visibleLinking: false,
      childTileId: undefined,
      exportLevel: false,
      importLevel: false,
      levelFile: undefined,
      url: undefined,
      visibleRelation: false,
      parentRelation: [],
      isAdjustment: false,
      levelName: undefined,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      moveTakeoff: false,
      selectedKeys: [],
      selectedTiles: [],
      tileNames: [],
      parentTitle: 'Parent level',
      childTitle: 'Child level',
      levelTiles: [],
      importColDef: [
        {
          headerName: 'Description',
          field: 'description',
          width: 300,
          wrapText: true,
          cellRenderer: 'toolTipRenderer',
          autoHeight: true,
        },
        {
          headerName: 'Validation Message',
          field: 'validationMessage',
          width: 300,
          wrapText: true,
          cellRenderer: 'validationRenderer',
          autoHeight: true,
        },
      ],
      linkTakeoff: false,
      isArchive: false,
    }
  },
  beforeMount() {
    this.isArchive = _.get(this.projectData, 'isArchive', false)
    this.loadingConfig()
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$root.$on('addLevel', this.addLevel)
    this.$root.$on('onMoveTakeoffs', this.onMoveTakeoffs)
    this.$root.$on('orderingTiles', this.orderingTiles)
    this.$root.$on('onLinkTakeoffs', this.onLinkTakeoffs)
  },
  beforeDestroy() {
    // this.$root.$off('addLevel')
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          headerName: '',
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          suppressSizeToFit: true,
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          floatingFilter: false,
          width: 3,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellRenderer: 'actionCellRenderer',
          cellRendererParams: {
            name: 'validTakeoff',
          },
        },
        {
          headerName: 'Cost Type',
          field: 'costType',
          headerTooltip: 'Cost Type',
          tooltipField: 'costType',
          width: 100,
          hide: true,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          tooltipField: 'contract',
          width: 100,
          hide: true,
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          headerTooltip: 'Cat Code',
          width: 100,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dynamicTable' },
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          suppressSizeToFit: true,
        },
        {
          headerName: 'Description',
          field: 'takeoff',
          headerTooltip: 'Description',
          width: 300,
          wrapText: false,
          filter: 'customFilter',
          editable: false,
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: { type: 'dynamicTable' },
        },
        {
          headerName: 'Cost',
          field: 'unitCost',
          headerTooltip: 'Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          editable: false,
          resizable: true,
          headerClass: 'header-right',
          cellRendererParams: { type: 'dynamicTable' },
          suppressSizeToFit: true,
        },
      ]
    },

    getData() {
      this.loader = true
      this.moveTakeoff = false
      this.loading = false
      instance
        .get(
          projectAPIs.project.asset.actualCost.level.list(
            this.$route.params.id,
            this.assetId,
          ),
        )
        .then(response => {
          this.parentLevelTotal = 0
          this.list = _.get(response.data, 'result', [])
          this.list.forEach(element => {
            this.parentLevelTotal = 0
            if (!element.tiles) {
              Object.assign(element, {
                tiles: [],
                totalCost: 0,
                parentTotal: 0,
              })
              if (element.sequence === 1) {
                this.$emit(
                  'calculateLevelTotal',
                  this.parentLevelTotal,
                  element.assetId,
                )
              }
            } else if (element.tiles.length > 0) {
              element.tiles.forEach(tile => {
                if (element.sequence > 1) {
                  Object.assign(tile, {
                    parentTotal: tile.takeoffs.reduce((total, cost) => {
                      return total + (cost.unitCost || 0)
                    }, 0),
                  })
                }
                this.takeoffs = [...tile.takeoffs, ...this.takeoffs]
              })
              const takeoffs = element.tiles.map(i => i.takeoffs)
              takeoffs.forEach(element => {
                const unitCost = element.map(i => i.unitCost)
                const total = unitCost.reduce((total, cost) => {
                  return total + (cost || 0)
                }, 0)
                this.parentLevelTotal = this.parentLevelTotal + total
              })
              if (
                String(this.parentLevelTotal) === '-0' ||
                String(this.parentLevelTotal) === '-0.0' ||
                String(this.parentLevelTotal) === '-0.00'
              ) {
                this.parentLevelTotal = 0
              }
              if (element.sequence === 1) {
                this.$emit(
                  'calculateLevelTotal',
                  this.parentLevelTotal,
                  element.assetId,
                )
              }
              Object.assign(element, {
                totalCost: this.parentLevelTotal > 0 ? this.parentLevelTotal : 0,
              })
            }
          })
          this.$emit('setLevels', {
            assetId: this.assetId,
            levelCount: this.list.length,
          })
          this.loader = false
          if (this.list.length === 4 && this.visible) {
            this.visible = false
            this.form.levelId = undefined
          } else if (this.visible) {
            const level = _.maxBy(this.list, 'sequence')
            this.form.levelId = level.id
            this.onLevelChange(level.id)
          } else {
            this.form.levelId = undefined
          }
          setTimeout(() => {
            this.cardHeight = calculateHeight(
              'actualCostLevel',
              true,
              false,
              false,
              true,
            )
            this.tileCardHeight = calculateHeight(
              'actualCostTile',
              true,
              false,
              false,
              true,
            )
          }, 2000)
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    addLevel(assetId) {
      if (this.projectData.assetId === assetId) {
        this.$notification.destroy()
        this.parentTitle = 'Parent Level'
        this.childTitle = 'Child Level'
        this.visible = true
        const level = _.maxBy(this.list, 'sequence')
        this.form.levelId = level.id
        this.onLevelChange(level.id)
      }
    },

    closeLevel(flag) {
      this.visible = flag
      if (flag) {
        this.getData()
      }
    },

    addTile(record) {
      this.levelIndex = this.list.findIndex(i => i.id === record.id)
      this.form.id = undefined
      this.form.name = undefined
      this.form.sequence = undefined
      this.onAddTile(false, record)
    },

    onEdit(level) {
      if (!this.isArchive) {
        this.form.id = level.id
        this.form.name = level.levelName
        this.editLevel = true
      }
    },

    cancelEdit(record) {
      this.form.id = undefined
      this.form.name = undefined
      this.form.sequence = undefined
      this.editLevel = false
    },

    onUpdate() {
      if (this.form.name.length > 100) {
        showNotification(
          'warning',
          'Level',
          'Level name must be less than or equals to 100 characters!',
        )
      } else {
        this.loaderText = true
        const url = projectAPIs.project.asset.actualCost.level.update(
          this.$route.params.id,
          this.assetId,
          this.form.id,
        )
        instance
          .patch(url, { levelName: this.form.name })
          .then(response => {
            const index = this.list.findIndex(i => i.id === this.form.id)
            this.list[index].levelName = this.form.name
            this.form.id = undefined
            this.form.name = undefined
            this.form.sequence = undefined
            this.form.type = '1'
            this.form.levelId = undefined
            this.loaderText = false
            this.editLevel = false
          })
          .catch(err => {
            this.loaderText = false
            errorService(err)
          })
      }
    },

    deleteLevel(level) {
      if (level.tiles && level.tiles.length > 0) {
        showNotification(
          'warning',
          'Level',
          'User needs to remove all the tiles in order to delete level!',
        )
      } else if (this.list.length === 1) {
        showNotification(
          'warning',
          'Level',
          'Asset must have at least one level!',
        )
      } else {
        const that = this
        this.$confirm({
          title: `Are you sure you want to delete ${level.levelName} ?`,
          content: h => (
            <div style="color:red;">
              <p>This action will delete all information related to level</p>
              <p>Please confirm</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(level.id)
          },
          onCancel() {},
          class: 'test',
        })
      }
    },

    confirmDelete(id) {
      this.loader = true
      instance
        .delete(
          `${projectAPIs.project.asset.actualCost.level.delete(
            this.$route.params.id,
            this.assetId,
            id,
          )}`,
        )
        .then(response => {
          this.loader = false
          this.getData()
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    onEditTitle(tile) {
      if (!this.isArchive) {
        this.levelIndex = this.list.findIndex(i => i.id === tile.levelId)
        this.form.id = tile.id
        this.form.name = tile.tileName
        this.form.sequence = tile.sequence
        this.form.levelId = tile.levelId
        this.editTile = true
      }
    },

    cancelEditTitle(record) {
      const index = this.list[this.levelIndex].tiles.findIndex(
        i => i.id === record.id,
      )
      this.list[this.levelIndex].tiles[index].tileName = record.tileName
      this.form.id = undefined
      this.form.name = undefined
      this.form.sequence = undefined
      this.editTile = false
    },

    onAddTile(flag, item) {
      this.loader = true
      const url = projectAPIs.project.asset.actualCost.level.tile.add(
        this.$route.params.id,
        this.assetId,
        item.id,
      )
      instance
        .post(url, { isAdjustmentTile: flag })
        .then(response => {
          this.getData()
          this.isAddTile = false
          this.isAdjustmentTile = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    onUpdateTile() {
      if (this.form.name.length > 100) {
        showNotification(
          'warning',
          'Tile',
          'Tile name must be less than or equals to 100 characters!',
        )
      } else {
        this.loaderTileText = true
        const url = projectAPIs.project.asset.actualCost.level.tile.update(
          this.$route.params.id,
          this.assetId,
          this.form.levelId,
        )
        instance
          .patch(url, [
            {
              id: this.form.id,
              tileName: this.form.name,
              sequence: this.form.sequence,
            },
          ])
          .then(response => {
            const index = this.list[this.levelIndex].tiles.findIndex(
              i => i.id === this.form.id,
            )
            this.list[this.levelIndex].tiles[index].tileName = this.form.name
            this.form.id = undefined
            this.form.name = undefined
            this.form.sequence = undefined
            this.form.levelId = undefined
            this.loaderTileText = false
            this.editTile = false
            if (this.list[this.levelIndex].sequence > 1) {
              const level = this.list.find(
                i => i.sequence === this.list[this.levelIndex].sequence - 1,
              )
              if (level) {
                if (level.tiles && level.tiles.length > 0) {
                  let takeoffs = []
                  level.tiles.forEach(element => {
                    takeoffs = [...element.takeoffs, ...takeoffs]
                  })
                  const isLinked = takeoffs.some(
                    i =>
                      i.childTileId ===
                      this.list[this.levelIndex].tiles[index].id,
                  )
                  if (isLinked) {
                    this.getData()
                  }
                }
              }
            }
          })
          .catch(err => {
            this.loaderTileText = false
            errorService(err)
          })
      }
    },

    deleteTile(tile, item) {
      this.levelIndex = this.list.findIndex(i => i.id === tile.levelId)
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${tile.tileName} ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will delete all information related to level</p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmTileDelete(tile.id, item)
        },
        onCancel() {},
        class: 'test',
      })
    },

    confirmTileDelete(id, item) {
      this.loader = true
      instance
        .delete(
          `${projectAPIs.project.asset.actualCost.level.tile.delete(
            this.$route.params.id,
            this.assetId,
            item.id,
            id,
          )}`,
        )
        .then(response => {
          this.getData()
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    showTakeoffs(record, item, type) {
      const list = [...this.list]
      this.$notification.destroy()
      this.costDetails = record
      this.type = type
      this.sequence = item.sequence
      const tile = list.find(i => i.sequence === item.sequence + 1)
      this.tiles = tile ? tile.tiles : []
      this.levelTiles = item ? _.get(item, 'tiles', []) : []
      if (type === 'Tile') {
        this.visibleTakeoff = true
      } else {
        this.$root.$off('deleteTileTakeoff')
        this.visibleTile = true
      }
    },

    closeTakeoff(flag, isUpdate) {
      this.visibleTakeoff = flag
      if (isUpdate) {
        this.getData()
      }
    },

    closeTile(flag, isUpdate) {
      this.visibleTile = flag
      this.visibleMoveTile = flag
      this.$root.$off('cloneLevelTileTakeoff')
      this.$root.$off('deleteLevelTileTakeoff')
      this.$root.$off('handleTileChange')
      this.$root.$off('onUpdateAdjustmentTakeoff')
      if (isUpdate) {
        this.getData()
      }
    },

    deleteTakeoffs(record) {
      const list = [...this.list]
      let index
      record.map(element => {
        index = list.findIndex(i => i.id === element.levelId)
        const tileIndex = list[index].tiles.findIndex(
          i => i.id === element.tileId,
        )
        const takeoffIndex = list[index].tiles[tileIndex].takeoffs.findIndex(
          i => i.id === element.id,
        )
        if (takeoffIndex > -1) {
          list[index].tiles[tileIndex].takeoffs.splice(takeoffIndex, 1)
        }
      })
      const takeoffs = list[index].tiles.map(i => i.takeoffs)
      takeoffs.forEach(element => {
        const unitCost = element.map(i => i.unitCost)
        const total = unitCost.reduce((total, cost) => {
          return total + (cost || 0)
        }, 0)
        this.parentLevelTotal = this.parentLevelTotal + total
      })
      if (
        String(this.parentLevelTotal) === '-0' ||
        String(this.parentLevelTotal) === '-0.0' ||
        String(this.parentLevelTotal) === '-0.00'
      ) {
        this.parentLevelTotal = 0
      }
      if (list[index].sequence === 1) {
        this.$emit(
          'calculateLevelTotal',
          this.parentLevelTotal,
          list[index].assetId,
        )
      }
      list[index].totalCost =
        this.parentLevelTotal > 0 ? this.parentLevelTotal : 0
      this.list = list
    },

    handleCancel() {
      this.form.name = undefined
      this.form.sequence = undefined
      this.form.type = '2'
      this.form.levelId = undefined
      this.levelDetails = undefined
      this.isAdjustment = false
      this.visible = false
      this.$emit('closeLevel', false)
    },

    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.onAdd()
        }
      })
    },

    onLevelChange(value) {
      const level = this.list.find(i => i.id === value)
      this.form.sequence = level ? level.sequence : 0
      this.levelDetails = level
      if (level.canAddChild) {
        this.form.type = '2'
      } else if (level.canAddParent) {
        this.form.type = '1'
      } else {
        this.form.type = undefined
      }
      if (level) {
        this.getTooltip(level)
      }
    },

    onAdd() {
      const url = projectAPIs.project.asset.actualCost.level.add(
        this.$route.params.id,
        this.assetId,
      )
      instance
        .post(url, {
          levelName: this.form.name,
          sequence:
            this.form.type === '1' ? this.form.sequence : this.form.sequence + 1,
        })
        .then(response => {
          this.form.name = undefined
          this.form.sequence = undefined
          this.form.type = '2'
          this.form.levelId = undefined
          this.levelDetails = undefined
          this.isAdjustment = false
          this.parentTitle = 'Parent Level'
          this.childTitle = 'Child Level'
          this.getData()
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    calculateTileTotal(takeoffs) {
      const total = takeoffs.reduce((total, takeoff) => {
        if (!takeoff.isAdjustmentTakeoff) {
          return total + (takeoff.unitCost ? takeoff.unitCost : 0)
        }
      }, 0)
      return total
    },

    highlightRows(checked, record) {
      this.childTileId = checked ? record.id : undefined
      this.visibleLinking = checked
    },

    downloadTemplate(id) {
      this.url = projectAPIs.project.asset.actualCost.level.downloadLevelDetails(
        this.$route.params.id,
        this.assetId,
        id,
      )
      this.exportLevel = true
    },

    importTemplate(event, id) {
      this.levelFile = event.file
      this.url = projectAPIs.project.asset.actualCost.level.import(
        this.$route.params.id,
        this.assetId,
        id,
      )
      this.importLevel = true
      const msg = 'Please wait while import levels'
      this.$root.$emit('popupUpdation', true, true, msg)
    },

    beforeUpload(file) {
      const isValid = checkFiles(file.type)
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    clickedCancel() {
      this.exportLevel = false
      this.importLevel = false
    },

    refreshLevels() {
      this.importLevel = false
      this.getData()
    },

    showTakeoffRelation(record, item) {
      const list = _.cloneDeep(this.list)
      this.$notification.destroy()
      this.costDetails = record
      this.sequence = item.sequence
      this.parentRelation = list.filter(i => i.sequence === item.sequence - 1)
      const tiles = list.find(i => i.sequence === item.sequence)
      if (tiles) {
        const tileList = tiles.tiles.filter(i => i.id === record.id)
        delete tiles['tiles']
        const levelDetails = tiles
        Object.assign(levelDetails, { tiles: [...tileList] })
        this.parentRelation.push(levelDetails)
      }
      this.visibleRelation = true
    },

    closeRelation() {
      this.visibleRelation = false
    },

    linkTakeoffs(url, type, record, tileId, tileDetails) {
      let isValid = true
      const title = `You can't ${
        type === 'link' ? 'link' : 'move'
      } line item which is already linked to the tile on child level`
      const description = `Please unselect or unlink the above line items before  ${
        type === 'link' ? 'linking to child' : 'moving to other tile'
      }.`
      if (this.selectedKeys.length > 0) {
        const isLinked = this.selectedKeys.some(i => i.childTileId)
        var that = this
        if (isLinked) {
          isValid = false
          const h = this.$createElement
          this.$info({
            title: title,
            content: h('div', {}, [
              h(
                'div',
                { attrs: { class: 'linked-takeoff-div' } },
                that.showLinkedTakeoffs(h),
              ),
              h('p', { attrs: { class: 'warning-message' } }, description),
            ]),
            onOk() {},
          })
        } else {
          this.selectedKeys = this.selectedKeys.filter(
            i => i.levelId === tileDetails.levelId,
          )
        }
      } else if (record && record.childTileId) {
        isValid = false
        var self = this
        const h = this.$createElement
        this.$info({
          title: title,
          content: h('div', {}, [
            h(
              'div',
              { attrs: { class: 'linked-takeoff-div' } },
              self.showLinkedTakeoff(h, [record], tileDetails),
            ),
            h('p', { attrs: { class: 'warning-message' } }, description),
          ]),
          onOk() {},
        })
      } else if (!record) {
        isValid = false
        const h = this.$createElement
        this.$info({
          title: 'Move Takeoffs',
          content: h('div', {}, [
            h(
              'p',
              { attrs: { class: 'warning-message' } },
              `Please select atleast one line item to ${
                type === 'link' ? 'link' : 'move'
              }`,
            ),
          ]),
          onOk() {},
        })
      }
      if (isValid) {
        let ids = this.selectedKeys.length > 0 ? this.selectedKeys : [record]
        ids = _.sortBy(ids, ['id'])
        let request = []
        switch (type) {
          case 'new':
          case 'existing':
            request = ids.map(i => i.id)
            break

          default:
            ids.forEach(element => {
              request.push({
                id: element.id,
                childTileId: tileId,
              })
            })
            this.linkTakeoff = true
        }

        this.loader = true
        this.moveTakeoff = true
        instance
          .patch(url, request)
          .then(response => {
            this.selectedKeys = []
            this.selectedTiles = []
            this.tileNames = []
          })
          .catch(err => {
            this.loader = false
            this.moveTakeoff = false
            errorService(err)
          })
      }
    },

    showLinkedTakeoffs(h) {
      const row = []
      this.selectedKeys
        .filter(i => i.childTileId)
        .forEach(element => {
          let tile = this.tileNames.find(i => i.id === element.tileId)
          tile = tile ? `${tile.tileName} - ` : ''
          row.push(
            h(
              'p',
              { attrs: { class: 'linked-takeoff' } },
              `${tile} ${element.takeoff}`,
            ),
          )
        })
      return row
    },

    showLinkedTakeoff(h, data, tileDetails) {
      const row = []
      data
        .filter(i => i.childTileId)
        .forEach(element => {
          row.push(
            h(
              'p',
              { attrs: { class: 'linked-takeoff' } },
              `${tileDetails.tileName} ${element.takeoff}`,
            ),
          )
        })
      return row
    },

    onMoveTakeoffs() {
      if (this.moveTakeoff) {
        this.getData()
      }
    },

    getTiles(item) {
      let tiles = []
      this.list.forEach(element => {
        tiles = [
          ...tiles,
          ...element.tiles.filter(i => i.id !== item.id && !i.isAdjustmentTile),
        ]
      })
      return tiles
    },

    calculateTileHeight(id) {
      return setTimeout(() => {
        this.tileCardHeight = calculateHeight(id, true, false, false, true)
        return this.tileCardHeight
      }, 2000)
    },

    orderingTiles(assetId) {
      if (this.projectData.assetId === assetId) {
        this.$notification.destroy()
        this.visibleMoveTile = true
      }
    },

    onSelectedKeys(data, tileDetails) {
      this.selectedKeys = this.selectedKeys.filter(
        i => i.tileId !== tileDetails.id,
      )
      this.tileNames = this.tileNames.filter(i => i.id !== tileDetails.id)
      this.selectedKeys = [...this.selectedKeys, ...data]
      const tiles = this.selectedKeys.map(i => i.tileId)
      this.selectedTiles = [...new Set(tiles)]
      this.tileNames.push({
        id: tileDetails.id,
        tileName: tileDetails.tileName,
      })
    },

    getTooltip(level) {
      const takeoffs = [...this.takeoffs]
      const tiles = level.tiles
      const isAdjustmentTile = tiles.some(i => i.isAdjustmentTile)
      const isLinked = takeoffs.some(
        i => i.levelId === level.id && i.childTileId,
      )
      this.parentTitle = 'Parent level'
      this.childTitle = 'Child level'
      if (!level.canAddParent && !level.canAddChild) {
        if (isAdjustmentTile) {
          this.parentTitle = `You can not create parent level as ${level.levelName} is having adjustment tile.`
        }
        if (isLinked) {
          this.childTitle = `You can not create child level as ${level.levelName} is linked with child level.`
          if (!isAdjustmentTile) {
            this.parentTitle = `You can not create parent level as ${level.levelName} is linked with parent level.`
          }
        } else if (!isAdjustmentTile) {
          this.parentTitle = `You can not create parent level as ${level.levelName} is linked with parent level.`
        }
      } else if (!level.canAddParent) {
        if (isAdjustmentTile) {
          this.parentTitle = `You can not create parent level as ${level.levelName} is having adjustment tile.`
        } else {
          this.parentTitle = `You can not create parent level as ${level.levelName} is linked with parent level.`
        }
      } else if (!level.canAddChild) {
        if (isLinked) {
          this.childTitle = `You can not create child level as ${level.levelName} is linked with child level.`
        }
      }
    },

    exportTemplate(id) {
      this.$emit('downloadTemplate', id)
    },

    reloadLevels() {
      this.moveTakeoff = true
    },

    onLinkTakeoffs() {
      if (this.linkTakeoff) {
        this.linkTakeoff = false
        this.getData()
      }
    },
  },
}
